import { Dispatch } from 'react'
import {
  SET_BACK_PATHNAME,
  SET_CLOSE_PATHNAME,
  SET_IS_BACK_BUTTON_VISIBLE,
  SET_IS_CLOSE_BUTTON_VISIBLE,
} from './constants'
import { NavbarContextAction } from './types'

export const setBackPathname = (
  dispatch: Dispatch<NavbarContextAction>,
  backPathname: string
) => {
  dispatch({
    type: SET_BACK_PATHNAME,
    backPathname,
  })
}

export const setClosePathname = (
  dispatch: Dispatch<NavbarContextAction>,
  closePathname: string
) => {
  dispatch({
    type: SET_CLOSE_PATHNAME,
    closePathname,
  })
}

export const setIsBackButtonVisible = (
  dispatch: Dispatch<NavbarContextAction>,
  isBackButtonVisible: boolean
) => {
  dispatch({
    type: SET_IS_BACK_BUTTON_VISIBLE,
    isBackButtonVisible,
  })
}

export const setIsCloseButtonVisible = (
  dispatch: Dispatch<NavbarContextAction>,
  isCloseButtonVisible: boolean
) => {
  dispatch({
    type: SET_IS_CLOSE_BUTTON_VISIBLE,
    isCloseButtonVisible,
  })
}
